import React from 'react'
import { Icon } from 'common-components'
import CheckIcon from 'assets/svgr-icons/Check.svg'
import * as Styled from './styled'

interface IAspectRatioOptionProps {
  key: 'landscape' | 'portrait'
  label: string
  ratio: string
  icon: React.ReactNode
  isSelected: boolean
  onClick: () => void
}

const AspectRatioOption: React.FC<IAspectRatioOptionProps> = ({
  label,
  ratio,
  icon,
  isSelected,
  onClick
}) => {
  return (
    <Styled.Item $selected={isSelected} onClick={onClick}>
      <Styled.ItemLeft>
        <Styled.IconBox>{icon}</Styled.IconBox>
        <Styled.ItemTitle>
          <Styled.ItemHeader>{label}</Styled.ItemHeader>
          <Styled.ItemSub>
            <span> {ratio} </span>
          </Styled.ItemSub>
        </Styled.ItemTitle>
      </Styled.ItemLeft>
      {isSelected && (
        <Styled.CheckmarkWrapper>
          <Icon icon={<CheckIcon />} size="medium" color="primaryDark" />
        </Styled.CheckmarkWrapper>
      )}
    </Styled.Item>
  )
}

export default AspectRatioOption
